import React from 'react';

class WizardItemRedirectResult extends React.Component {

    constructor(props) {

	    super(props);
	    this.state = {
		    value: this.props.data.Answer,
		    hovered: null
	    };
    }

    render() {

        //redirect
        if(this.props.data.RedirectUrl){
            location.href = this.props.data.RedirectUrl;
        }

        return (
            <div></div>            
        )
    }
}

export default WizardItemRedirectResult;